import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { operationsClient, apiPatch } from '@/lib/api';
import { schedulerEndpoints } from '@/lib/api/endpoints';
import { bookingKeys, schedulerKeys } from '@/lib/queryKeys';
import type { SchedulerBooking } from '@/types/scheduler';

/** Mark an appointment DISPATCHED (tech on the way) from the board. */
export function useDispatchBooking() {
  const queryClient = useQueryClient();

  return useApiMutation<SchedulerBooking, { id: string }>({
    mutationFn: ({ id }) =>
      apiPatch<SchedulerBooking, { status: 'dispatched' }>(
        operationsClient,
        schedulerEndpoints.bookingStatus(id),
        { status: 'dispatched' },
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: schedulerKeys.bookings() });
      void queryClient.invalidateQueries({ queryKey: bookingKeys.all() });
      toast.success('Technician dispatched');
    },
  });
}
